var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('iframe',{staticStyle:{"display":"none"},attrs:{"id":"iframe-page","src":_vm.tokenIframeUrl,"frameborder":"0"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }